/**
 * Checks whether the current browser is WebKit (Safari/iOS), which rasterises
 * box-shadow inside foreignObject incorrectly.
 *
 * @return {Boolean}
 *         true if the browser is WebKit, false otherwise.
 */
export function isWebKit() {

    return (
        /AppleWebKit/.test(navigator.userAgent)
        && !/Chrome|Chromium|Edg|OPR\//.test(navigator.userAgent)
    );

}

/**
 * Patches a cloned node for WebKit screenshots: box-shadow inside
 * foreignObject rasterises incorrectly (the outer shadow becomes an opaque
 * block and inset shadows leak as straight-edged stripes across the token).
 * box-shadow is dropped entirely, the outer shadow is reproduced with
 * drop-shadow() and the inset shading is emulated with a radial-gradient
 * overlay, which clips to border-radius correctly.
 *
 * @param {Element} clone
 *        The cloned node to patch.
 */
export function patchCloneForWebKit(clone) {

    const style = clone.ownerDocument.createElement("style");
    style.textContent = [
        ".character,.reminder,.character__player-name{box-shadow:none!important}",
        ".character,.reminder{filter:drop-shadow(var(--shadow-amount, .1em) var(--shadow-amount, .1em) .2em rgb(0 0 0/80%))!important}",
        ".character.is-dead{filter:grayscale(1) brightness(.8) drop-shadow(var(--shadow-amount) var(--shadow-amount) .2em rgb(0 0 0/80%))!important}",
        ".character__player-name{filter:drop-shadow(var(--shadow-amount) var(--shadow-amount) .2em rgb(0 0 0/80%))!important}",
        ".reminder{position:relative}",
        ".ms-vignette{position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:1;background:radial-gradient(circle at 35% 30%,rgb(255 255 255/15%),transparent 35%),radial-gradient(circle,transparent 55%,rgb(138 77 15/80%) 100%)}",
        ".ms-vignette--dark{background:radial-gradient(circle at 35% 30%,rgb(255 255 255/8%),transparent 35%),radial-gradient(circle,transparent 50%,rgb(17 19 36/90%) 100%)}"
    ].join("");
    clone.append(style);

    clone.querySelectorAll(".character,.reminder,.character__player-name").forEach((el) => {

        const vignette = clone.ownerDocument.createElement("span");
        vignette.className = "ms-vignette"
            + (el.classList.contains("reminder") ? " ms-vignette--dark" : "");
        el.append(vignette);

    });

}
